import { useEffect, useMemo, useState } from "react"
import { toast } from "react-toastify"
import { Button, Modal, ModalBody } from "reactstrap"

import { confirm } from "components/Confirmation"
import CustomDropzone from "components/CustomDropzone"
import arquivoService from "services/ArquivoService"
import descarteService from "services/DescarteService"
import { DestinacaoMaterialDescarteEnum } from "services/DescarteService"

function parseBoolean(value) {
  if (value === true || value === 1 || value === '1' || value === 'true') {
    return true
  }
  return false
}

export default function ModalFinalizarDescarte({ config, onClosed }) {
  const [arquivoAssinado, setArquivoAssinado] = useState()
  const [arquivoCertificado, setArquivoCertificado] = useState()
  const [saving, setSaving] = useState(false)

  const exigeCertificado = useMemo(() => {
    if (!config) {
      return false
    }

    return config.destinacaoMaterial == DestinacaoMaterialDescarteEnum.DESCARTE_HOMOLOGADO &&
      parseBoolean(config.certificadoDescarte)
  }, [config])

  useEffect(() => {
    setArquivoAssinado()
    setArquivoCertificado()
    setSaving(false)
  }, [config])

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!arquivoAssinado) {
      toast('Selecione o arquivo da Solicitação Original Assinada')
      return
    }

    if (exigeCertificado && !arquivoCertificado) {
      toast('Selecione o arquivo de Certificado de Descarte')
      return
    }

    confirm({
      header: 'Finalização',
      text: 'Tem certeza que gostaria de continuar?',
      icon: 'bi-exclamation-triangle',
      onConfirm: async () => {
        try {
          setSaving(true)

          const data = {}

          const resArquivoAssinado = await arquivoService.upload(arquivoAssinado)
          if (resArquivoAssinado.success) {
            data.arquivoAssinado = { id: resArquivoAssinado.data }
          } else {
            toast('Erro ao enviar arquivo')
            return
          }

          if (exigeCertificado) {
            const resArquivoCertificado = await arquivoService.upload(arquivoCertificado)
            if (resArquivoCertificado.success) {
              data.arquivoCertificado = { id: resArquivoCertificado.data }
            } else {
              toast('Erro ao enviar arquivo')
              return
            }
          }

          const res = await descarteService.finalize(
            config.idContrato,
            config.idDescarte,
            data.arquivoAssinado,
            data.arquivoCertificado
          )

          if (res.success) {
            toast('Descarte finalizado com sucesso!')
            if (config.onChange) {
              await config.onChange()
            } else if (onClosed) {
              onClosed()
            }
          } else {
            toast('Erro ao finalizar descarte')
          }
        } catch (ex) {
          if (!!ex.response?.data?.message) {
            toast(ex.response.data.message)
          } else {
            toast('Erro ao finalizar descarte')
          }
        } finally {
          setSaving(false)
        }
      }
    })
  }

  return (
    <Modal isOpen={!!config} size="lg">
      <ModalBody>
        <h2>Finalizar Descarte</h2>
        <hr />
        <form onSubmit={handleSubmit}>
          <div className="d-flex flex-row gap-5px flex-wrap">
            <div>
              Solicitação Original Assinada<br />
              <CustomDropzone
                value={arquivoAssinado}
                onChange={value => setArquivoAssinado(value)}
                onRemove={() => setArquivoAssinado(null)}
                edit={true}
              />
            </div>
            {exigeCertificado && (
              <div>
                Certificado de Descarte<br />
                <CustomDropzone
                  value={arquivoCertificado}
                  onChange={value => setArquivoCertificado(value)}
                  onRemove={() => setArquivoCertificado(null)}
                  edit={true}
                />
              </div>
            )}
          </div>
          <div className="text-right mt-4">
            <Button type="submit" color="primary" disabled={saving}>Salvar</Button>
            <Button type="button" color="primary" outline onClick={onClosed} disabled={saving}>Cancelar</Button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  )
}